"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CastingFormDataFromJSON = CastingFormDataFromJSON;
exports.CastingFormDataFromJSONTyped = CastingFormDataFromJSONTyped;
exports.CastingFormDataToJSON = CastingFormDataToJSON;
exports.CastingFormDataToJSONTyped = CastingFormDataToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function CastingFormDataFromJSON(json) {
    return CastingFormDataFromJSONTyped(json, false);
}
function CastingFormDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'formCode': !(0, runtime_1.exists)(json, 'formCode') ? undefined : json['formCode'],
        'season': !(0, runtime_1.exists)(json, 'season') ? undefined : json['season'],
        'fields': !(0, runtime_1.exists)(json, 'fields') ? undefined : (json['fields'].map(_1.CastingFormFieldFromJSON)),
        'privacyStatementUrl': !(0, runtime_1.exists)(json, 'privacyStatementUrl') ? undefined : json['privacyStatementUrl'],
        'title': !(0, runtime_1.exists)(json, 'title') ? undefined : json['title'],
        'lead': !(0, runtime_1.exists)(json, 'lead') ? undefined : json['lead'],
        'imageUrls': !(0, runtime_1.exists)(json, 'imageUrls') ? undefined : (0, _1.ImageUrlsFromJSON)(json['imageUrls']),
        'group': !(0, runtime_1.exists)(json, 'group') ? undefined : json['group'],
        'appTitle': !(0, runtime_1.exists)(json, 'appTitle') ? undefined : json['appTitle'],
    };
}
function CastingFormDataToJSON(value) {
    return CastingFormDataToJSONTyped(value, false);
}
function CastingFormDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'formCode': value.formCode,
        'season': value.season,
        'fields': value.fields === undefined ? undefined : (value.fields.map(_1.CastingFormFieldToJSON)),
        'privacyStatementUrl': value.privacyStatementUrl,
        'title': value.title,
        'lead': value.lead,
        'imageUrls': (0, _1.ImageUrlsToJSON)(value.imageUrls),
        'group': value.group,
        'appTitle': value.appTitle,
    };
}
